import { z } from 'zod';

import { actionIdSchema } from './chat-ids';

export const callbackActionDecisionSchema = z.object({
    accepted: z.boolean(),
    actionId: actionIdSchema,
    type: z.literal('decision'),
});

export type CallbackActionDecision = z.infer<typeof callbackActionDecisionSchema>;

export const callbackActionInputSchema = z.object({
    actionId: actionIdSchema,
    input: z.string(),
    type: z.literal('input'),
});

export type CallbackActionInput = z.infer<typeof callbackActionInputSchema>;

export const callbackActionSchema = z.discriminatedUnion('type', [
    callbackActionDecisionSchema,
    callbackActionInputSchema,
]);

export type CallbackAction = z.infer<typeof callbackActionSchema>;

export const callbackRequestSchema = z.object({
    actions: z.array(callbackActionSchema),
});

export type CallbackRequest = z.infer<typeof callbackRequestSchema>;
